import { navigate } from 'gatsby';
import React, { createContext } from 'react';
import { returnLocalisedPath } from '../globals';
// context
export const LocalContext = createContext('');

export default ({ children, locale, slug }) => {
  // naviguate to new locale
  const updateLocale = (newlocale) => {
    navigate(returnLocalisedPath(newlocale, ''));
  };

  // naviguate to new zone
  const updateZone = (newZone) => {
    if (typeof window !== 'undefined') {
      window.location.href = `${process.env.GATSBY_BASE_HOST}${newZone}`;
    }
  };

  return (
    <LocalContext.Provider value={[locale, updateLocale, updateZone, slug]}>
      {children}
    </LocalContext.Provider>
  );
};
